import dayjs from 'dayjs'
import { DateTimeFormat } from './Constants'

export const genTodayStart = () =>
  dayjs()
    .startOf('day')
    .format(DateTimeFormat)

export const genTodayEnd = () =>
  dayjs()
    .endOf('day')
    .format(DateTimeFormat)
